<template>
  <div style="position:relative">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px;"
    ></v-premium-plan-popup>
    <v-container>
      <div>
        <h3 class="headline">{{ $t('Cart Summary') }}</h3>

        <v-layout row wrap>
          <v-flex sm12 xs12 class="mb-4">
            <div>
              <date-filter
                v-model="selectedDate"
                @changeDate="onDateChanged"
                :default-filter="'today'"
              ></date-filter>
            </div>

            <v-divider class="mt-3"></v-divider>
          </v-flex>
          <v-flex sm6 xs12>
            <div
              class="nav nav-tabs"
              style="margin-bottom:10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'all'"
                :outline="filterApp != 'all'"
                :color="filterApp != 'all' ? 'grey' : 'primary'"
              >{{ $t('All') }} {{ `(${rawusers.length})` }}</v-btn>
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'facebook'"
                :outline="filterApp != 'facebook'"
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
              >{{ $t('facebook') }} {{ `(${facebooklength})` }}</v-btn>
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'line'"
                :outline="filterApp != 'line'"
                :color="filterApp != 'line' ? 'grey' : 'primary'"
              >{{ $t('line') }} {{ `(${linelength})` }}</v-btn>
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn
              @click="onDeleteAllInCart"
              color="primary"
              outline
              class="ma-0 mb-1"
              :disabled="selectedUsers.length == 0"
            >
              <v-icon class="mr-1">remove_shopping_cart</v-icon>
              {{ $t('Clear cart') }}
            </v-btn>
            <v-btn @click="exportCartSummary" color="grey" outline class="ma-0 mb-1">
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm12>
            <div>
              <div
                v-if="isCentralLive"
                class="nav nav-tabs"
                style="margin-bottom:10px; overflow-x: auto; white-space: nowrap"
              >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="filterCategoryStatus = 'all'"
                  :outline="filterCategoryStatus != 'all'"
                  :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }}</v-btn>
                <v-btn
                  small
                  v-for="(category, k) in categories"
                  :key="k"
                  depressed
                  class="ma-1"
                  @click="filterCategoryStatus = category"
                  :outline="filterCategoryStatus != category"
                  :color="filterCategoryStatus != category ? 'grey' : 'primary'"
                >{{ category }}</v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-data-table
          expand
          v-model="selectedUsers"
          :loading="loading"
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="filteredUser"
          class="elevation-1 scgallrenttable"
          select-all
        >
          <template v-slot:items="props">
            <tr style="cursor: pointer">
              <td style="width: 1%">
                <v-checkbox v-model="props.selected" primary hide-details color="primary"></v-checkbox>
              </td>
              <td @click="showCartDialog(props.item.id)" class="text-xs-center">
                <v-avatar size="30">
                  <img
                    v-if="props.item.profile_pic"
                    @error="onFailLoad"
                    :src="props.item.profile_pic"
                    width="30"
                    height="30"
                  />
                  <img
                    v-else
                    :src="'/static/img/assets/livechat/profile.png'"
                    width="30"
                    height="30"
                    :alt="props.item.name"
                  />
                </v-avatar>
              </td>
              <td @click="showCartDialog(props.item.id)" class="text-xs-left">{{ props.item.name }}</td>
              <td
                @click="showCartDialog(props.item.id)"
                class="text-xs-center"
              >{{ props.item.quantity | numberFormat }}</td>
              <td
                @click="showCartDialog(props.item.id)"
                class="text-xs-center"
              >{{ props.item.cartprice | numberFormat }}</td>
              <td
                @click="showCartDialog(props.item.id)"
                class="text-xs-center"
              >{{ props.item.timestamp | DateFormat('DD/MM/YYYY') }}</td>
              <td @click="showCartDialog(props.item.id)" class="text-xs-center">
                <v-btn
                  @click.stop="viewInbox(props.item.inboxurl)"
                  target="_blank"
                  small
                  depressed
                  round
                  color="#3b5998"
                  :dark="props.item.inboxurl ? true : false"
                  :disabled="!props.item.inboxurl"
                >
                  <i class="fab fa-facebook-square mr-1"></i>
                  {{ $t('View inbox') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div>
      <v-dialog width="660" v-model="showCart" persistent>
        <v-card>
          <div class="text-xs-right">
            <v-btn @click="close" icon small>
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
          <div>
            <v-layout>
              <v-flex class="text-xs-left my-2 ma-2">
                <span>{{ $t('Total') }}</span>
                <span class="primary--text" style="font-weight: 500;">
                  {{
                  cartitem.total | numberFormat
                  }}
                </span>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn @click="onDeleteSelected" outline color="primary">
                  <v-icon class="mr-1">remove_shopping_cart</v-icon>
                  {{ $t('Clear cart') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              expand
              :loading="cartloading"
              v-bind:pagination.sync="pagination"
              :headers="cartheaders"
              :items="cartitem.cartarray"
              class="elevation-1 scgallrenttable"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-center">
                    <v-avatar tile size="45">
                      <img
                        v-if="props.item.photourl"
                        @error="onFailLoad"
                        :src="props.item.photourl.split(';;')[0]"
                        width="30"
                        height="30"
                        :alt="props.item.name"
                      />
                      <img
                        v-else
                        :src="'/static/img/assets/livechat/profile.png'"
                        width="30"
                        height="30"
                        :alt="props.item.name"
                      />
                    </v-avatar>
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.option }}</td>
                  <td class="text-xs-center">{{ props.item.quantity | numberFormat }}</td>
                  <!-- <td
                    class="text-xs-center"
                    v-if="props.item.discountprice"
                  >{{ props.item.discountprice | numberFormat }}</td>-->
                  <!-- <td class="text-xs-center" v-else>{{ props.item.price | numberFormat }}</td> -->
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'

export default {
  components: {
    DateFilter,
  },
  data() {
    return {
      filterCategoryStatus: 'all',
      selectedDate: {
        start: moment().format('YYYY-MM-DD') + ' 00:00',
        end: moment().format('YYYY-MM-DD') + ' 23:59',
      },
      cartitem: [],
      search: '',
      filterApp: 'all',
      showCart: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        {
          text: '',
          value: 'photourl',
          align: 'center',
          width: '3%',
          sortable: false,
        },
        {
          text: this.$t('name'),
          value: 'name',
          align: 'left',
          width: 'auto',
        },
        {
          text: this.$t('Quantity'),
          value: 'quantity',
          align: 'center',
          width: '1%',
        },
        {
          text: this.$t('price'),
          value: 'cartprice',
          align: 'center',
          width: '1%',
        },
        {
          text: this.$t('Time'),
          value: 'cartprice',
          align: 'center',
          width: '1%',
        },
        {
          text: this.$t('Inbox'),
          value: 'inboxurl',
          align: 'center',
          width: '2%',
        },
      ],
      cartheaders: [
        {
          text: '',
          value: 'photourl',
          align: 'center',
          width: '3%',
        },
        {
          text: this.$t('name'),
          value: 'name',
          align: 'center',
          width: '3%',
        },
        {
          text: this.$t('option'),
          value: 'option',
          align: 'center',
          width: '1%',
        },
        {
          text: this.$t('Quantity'),
          value: 'quantity',
          align: 'center',
          width: '1%',
        },
        // {
        //   text: this.$t('Price'),
        //   value: 'discountprice',
        //   align: 'center',
        //   width: '2%'
        // }
      ],
      loading: false,
      cartloading: false,
      rawusers: [],
      products: [],
      selectedUsers: [],
      selectedUser: null,
    }
  },
  computed: {
    categories() {
      var uniq = [...new Set(this.rawusers.map((el) => el.categoryname))]
      return uniq
    },
    ...mapGetters(['selectedBot']),
    facebooklength() {
      return this.rawusers.filter((el) => el.app == 'facebook').length
    },
    linelength() {
      return this.rawusers.filter((el) => el.app == 'line').length
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    filteredUser() {
      var result
      var user = this.rawusers
      if (this.search) {
        user = user.filter((val) => val.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      result = user.filter((el) => {
        if (this.filterApp != 'all') {
          return el.app == this.filterApp
        } else {
          return true
        }
      })
      if (this.filterCategoryStatus != 'all') {
        result = result.filter((el) => el.categoryname == this.filterCategoryStatus)
      }
      return result
    },
  },
  mounted() {
    this.getUser()
    // this.getProducts()
  },
  methods: {
    async onDeleteSelected() {
      if (this.selectedUser) {
        this.selectedUsers.push(this.selectedUser)
        await this.onDeleteAllInCart()
        this.showCart = false
      }
    },
    async onDeleteAllInCart() {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to clear cart'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
      })

      if (result.value) {
        var userid = this.selectedUsers.map((el) => {
          return el.id
        })
        this.loading = true
        await this.deleteAllInCart(userid)

        userid.map((el) => {
          var index = this.rawusers.findIndex((user) => {
            return user.id == el
          })
          if (index != -1) {
            this.rawusers.splice(index, 1)
          }
        })

        this.loading = false
      }
    },
    deleteAllInCart(userid) {
      return new Promise((resolve, reject) => {
        if (!this.selectedUsers || this.selectedUsers.length == 0) {
          reject()
        }
        var data = {
          pageid: this.selectedBot.pageid,
          userid_arr: userid,
        }
        api.deleteAllInCart(data, (error, response) => {
          if (error) {
            console.error(error)
          }
          resolve(response)
        })
      })
    },
    onDateChanged() {
      this.getUser()
    },
    close() {
      this.cartitem = []
      this.showCart = false
    },
    viewInbox(link) {
      window.open(link, '_blank')
    },
    showCartDialog(id) {
      this.showCart = id

      var user = this.rawusers.find((el) => {
        return el.id == id
      })
      this.selectedUser = user
      this.getCart(id)
    },
    getCart(id) {
      this.cartloading = true
      api.getusercart({ pageid: this.selectedBot.pageid, userid: id }, (err, response) => {
        this.cartloading = false
        if (response && response.cartarray) {
          this.cartitem = response
        }
      })
    },
    onFailLoad: function (e) {
      // console.log(e)
      e.target.src = '/static/img/assets/livechat/profile.png'
      // this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getUser() {
      this.loading = true
      api.getcmsviewcarts(
        {
          pageid: this.selectedBot.pageid,
          startdate: this.selectedDate.start,
          enddate: this.selectedDate.end,
        },
        (err, response) => {
          this.loading = false
          if (response.data) {
            this.rawusers = response.data
          }
        }
      )
    },
    exportCartSummary: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      api.getexportcmsviewcarts(
        {
          pageid: this.selectedBot.pageid,
          startdate: this.selectedDate.start,
          enddate: this.selectedDate.end,
          app: this.filterApp,
        },
        (err, response) => {
          if (response.responsecode == 200) {
            $.each(response.data, function (index, item) {
              csvContent +=
                `${item.id},${item.first_name},${item.last_name},${
                  item.inboxurl
                },"{${item.productlist[0].map((el) => '{' + el + '}')}}"` + '\r\n'
            })

            vm.exportCsv(csvContent, 'cartsummary')
          }
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CartSummary.vue